export const USER_TYPES = {
  STATION_USER: 'STATION_USER',
  ANY_OTHER_ES_USER: 'ANY_OTHER_ES_USER',
  TRAVEL_AGENT: 'TRAVEL_AGENT'
};
